/** Early DOM class so first paint isn't a white flash. Vuetify sync happens in layout. */
export default defineNuxtPlugin({
  name: 'jgi-theme-dom',
  enforce: 'pre',
  setup() {
    if (!import.meta.client) return;
    const raw = localStorage.getItem('jgi_theme');
    const dark = raw === 'dark';
    document.documentElement.classList.toggle('jgi-dark', dark);
    document.documentElement.dataset.theme = dark ? 'dark' : 'light';
    document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  },
});
